import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import About from './components/About';
import Donate from './components/Donate';
// import videosrc from './assets/herosectionvideo.mp4'
import Slideshow from './components/Slideshow';
import StorySection from './components/StorySection';
import Getinvolved from './components/Getinvolved';
import ArticlePage from "./components/ArticlePage";
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
// import RazorpayPayment from './components/RazorpayPayment';


const Home = () => (
  <>
     {/* <section className="bg-gray-100 py-12 px-4 md:px-12"> 
    <div className="flex justify-center">
      <div className="w-full max-w-6xl aspect-video">
        <iframe
          className="w-full h-full rounded-lg shadow-lg"
          src={videosrc}
          title="Empowerment Story"
          type = "video/mp4"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </section> */}
  <div>
   <div className="slider">
           <Slideshow />
           </div> 
    <StorySection />
    </div>
  </>
);

const NotFound = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-700">
    <h1 className="text-6xl font-bold mb-4">404</h1>
    <p className="text-2xl mb-6">Oops! The page you're looking for doesn't exist.</p>
    <a href="/" className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">Go to Home</a>
  </div>
);

function App() {
 
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/donate" element={<Donate/>} />
         {/* <Route path="/donate" element={<RazorpayPayment amount={499} user={user}/>} /> */}
        <Route path="/involve" element={<Getinvolved/>} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path = "/stories" element = {<StorySection />}/>
         <Route path = "/stories" element = { <Footer />}/>
          <Route path = "/privacypolicy" element = { <PrivacyPolicy />}/>
        <Route path="/stories/:slug" element={<ArticlePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;